<template>
  <div class="ca-modulos">
    <header class="ca-cabecera">
      <div>
        <h1 class="ca-titulo">Modulos del sistema</h1>
        <p class="ca-subtitulo">Catalogo de modulos principales y sus submodulos.</p>
      </div>
      <button class="ca-boton ca-boton--primario" @click="abrirNuevoModulo">
        <i class="bi bi-plus-lg"></i> Nuevo modulo
      </button>
    </header>

    <div v-if="cargando" class="ca-info">Cargando...</div>
    <div v-else-if="!modulos.length" class="ca-info">No hay modulos registrados.</div>

    <article v-for="m in modulos" :key="m.id" class="ca-card">
      <div class="ca-card__header">
        <div class="ca-card__titulo">
          <i v-if="m.icono" :class="m.icono" class="ca-card__icono"></i>
          <strong>{{ m.nombre }}</strong>
          <span class="ca-codigo">{{ m.codigo }}</span>
          <span v-if="!m.activo" class="ca-badge ca-badge--neutro">inactivo</span>
        </div>
        <div class="ca-card__acciones">
          <button class="ca-boton ca-boton--xs ca-boton--secundario" @click="editarModulo(m)" title="Editar"><i class="bi bi-pencil"></i></button>
          <button class="ca-boton ca-boton--xs ca-boton--exito" @click="abrirNuevoSubmodulo(m)" title="Agregar submodulo"><i class="bi bi-plus"></i></button>
          <button class="ca-boton ca-boton--xs ca-boton--peligro" @click="eliminarModulo(m)" title="Eliminar"><i class="bi bi-trash"></i></button>
        </div>
      </div>

      <table v-if="m.submodulos.length" class="ca-tabla">
        <thead>
          <tr><th>Codigo</th><th>Nombre</th><th>Ruta</th><th>Estado</th><th></th></tr>
        </thead>
        <tbody>
          <tr v-for="s in m.submodulos" :key="s.id">
            <td><code class="ca-codigo">{{ s.codigo }}</code></td>
            <td>{{ s.nombre }}</td>
            <td><code class="ca-ruta">{{ s.ruta }}</code></td>
            <td><span :class="['ca-badge', s.activo ? 'ca-badge--exito' : 'ca-badge--neutro']">{{ s.activo ? 'activo' : 'inactivo' }}</span></td>
            <td class="ca-tabla__acciones">
              <button class="ca-boton ca-boton--xs ca-boton--secundario" @click="editarSubmodulo(m, s)"><i class="bi bi-pencil"></i></button>
              <button class="ca-boton ca-boton--xs ca-boton--peligro" @click="eliminarSubmodulo(s)"><i class="bi bi-trash"></i></button>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else class="ca-info ca-info--vacio">Sin submodulos.</div>
    </article>

    <!-- Modal modulo -->
    <div v-if="modalModulo" class="ca-modal-fondo" @click.self="modalModulo = null">
      <div class="ca-modal">
        <h2>{{ modalModulo.id ? 'Editar modulo' : 'Nuevo modulo' }}</h2>
        <label>Codigo<input v-model="modalModulo.codigo" class="ca-input"/></label>
        <label>Nombre<input v-model="modalModulo.nombre" class="ca-input"/></label>
        <label>Icono <small>(ej. bi bi-grid)</small><input v-model="modalModulo.icono" class="ca-input"/></label>
        <label>Orden<input v-model.number="modalModulo.orden" type="number" class="ca-input"/></label>
        <label class="ca-check">
          <input v-model="modalModulo.activo" type="checkbox"/> Activo
        </label>
        <div class="ca-modal__acciones">
          <button class="ca-boton ca-boton--secundario" @click="modalModulo = null">Cancelar</button>
          <button class="ca-boton ca-boton--primario" @click="guardarModulo" :disabled="guardando">Guardar</button>
        </div>
      </div>
    </div>

    <!-- Modal submodulo -->
    <div v-if="modalSubmodulo" class="ca-modal-fondo" @click.self="modalSubmodulo = null">
      <div class="ca-modal">
        <h2>{{ modalSubmodulo.id ? 'Editar submodulo' : 'Nuevo submodulo' }}</h2>
        <label>Codigo<input v-model="modalSubmodulo.codigo" class="ca-input"/></label>
        <label>Nombre<input v-model="modalSubmodulo.nombre" class="ca-input"/></label>
        <label>Ruta <small>(ej. ventas/facturas)</small><input v-model="modalSubmodulo.ruta" class="ca-input"/></label>
        <label>Orden<input v-model.number="modalSubmodulo.orden" type="number" class="ca-input"/></label>
        <label class="ca-check">
          <input v-model="modalSubmodulo.activo" type="checkbox"/> Activo
        </label>
        <div class="ca-modal__acciones">
          <button class="ca-boton ca-boton--secundario" @click="modalSubmodulo = null">Cancelar</button>
          <button class="ca-boton ca-boton--primario" @click="guardarSubmodulo" :disabled="guardando">Guardar</button>
        </div>
      </div>
    </div>

    <!-- Confirmacion -->
    <div v-if="confirmacion" class="ca-modal-fondo" @click.self="confirmacion = null">
      <div class="ca-modal ca-modal--confirm">
        <h2>{{ confirmacion.titulo }}</h2>
        <p>{{ confirmacion.mensaje }}</p>
        <div class="ca-modal__acciones">
          <button class="ca-boton ca-boton--secundario" @click="confirmacion = null">Cancelar</button>
          <button class="ca-boton ca-boton--peligro" @click="ejecutarConfirmacion">Eliminar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import controlAcceso from '@/services/controlAccesoService'
import { notifySuccess, notifyError } from '@/services/notificationService'

export default {
  name: 'ControlAccesoModulos',
  data() {
    return {
      cargando: false,
      guardando: false,
      modulos: [],
      modalModulo: null,
      modalSubmodulo: null,
      confirmacion: null,
    }
  },
  mounted() { this.cargar() },
  methods: {
    async cargar() {
      this.cargando = true
      try {
        const res = await controlAcceso.listarModulos()
        this.modulos = res.data || []
      } catch (e) {
        notifyError('No se pudieron cargar los modulos.')
      } finally { this.cargando = false }
    },
    abrirNuevoModulo() {
      this.modalModulo = { codigo: '', nombre: '', icono: '', orden: 0, activo: true }
    },
    editarModulo(m) {
      this.modalModulo = { ...m, activo: !!m.activo }
    },
    async guardarModulo() {
      const m = this.modalModulo
      if (!m.codigo || !m.nombre) { notifyError('Codigo y nombre son obligatorios.'); return }
      this.guardando = true
      try {
        if (m.id) await controlAcceso.actualizarModulo(m.id, m)
        else      await controlAcceso.crearModulo(m)
        notifySuccess('Modulo guardado.')
        this.modalModulo = null
        await this.cargar()
      } catch (e) {
        notifyError(e?.response?.data?.error || 'Error al guardar el modulo.')
      } finally { this.guardando = false }
    },
    eliminarModulo(m) {
      this.confirmacion = {
        titulo: 'Eliminar modulo',
        mensaje: `Se eliminara "${m.nombre}" y todos sus submodulos. Esta accion es irreversible.`,
        accion: async () => {
          try {
            await controlAcceso.eliminarModulo(m.id)
            notifySuccess('Modulo eliminado.')
            await this.cargar()
          } catch (e) {
            notifyError(e?.response?.data?.error || 'Error al eliminar.')
          }
        },
      }
    },
    abrirNuevoSubmodulo(m) {
      this.modalSubmodulo = { modulo_id: m.id, codigo: '', nombre: '', ruta: '', orden: 0, activo: true }
    },
    editarSubmodulo(m, s) {
      this.modalSubmodulo = { ...s, modulo_id: m.id, activo: !!s.activo }
    },
    async guardarSubmodulo() {
      const s = this.modalSubmodulo
      if (!s.codigo || !s.nombre || !s.ruta) { notifyError('Codigo, nombre y ruta son obligatorios.'); return }
      this.guardando = true
      try {
        if (s.id) await controlAcceso.actualizarSubmodulo(s.id, s)
        else      await controlAcceso.crearSubmodulo(s)
        notifySuccess('Submodulo guardado.')
        this.modalSubmodulo = null
        await this.cargar()
      } catch (e) {
        notifyError(e?.response?.data?.error || 'Error al guardar el submodulo.')
      } finally { this.guardando = false }
    },
    eliminarSubmodulo(s) {
      this.confirmacion = {
        titulo: 'Eliminar submodulo',
        mensaje: `Se eliminara "${s.nombre}". Esta accion es irreversible.`,
        accion: async () => {
          try {
            await controlAcceso.eliminarSubmodulo(s.id)
            notifySuccess('Submodulo eliminado.')
            await this.cargar()
          } catch (e) {
            notifyError(e?.response?.data?.error || 'Error al eliminar.')
          }
        },
      }
    },
    async ejecutarConfirmacion() {
      const accion = this.confirmacion?.accion
      this.confirmacion = null
      if (accion) await accion()
    },
  },
}
</script>

<style scoped>
.ca-modulos { color: var(--text-primary); }
.ca-cabecera { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 18px; gap: 16px; }
.ca-titulo { font-size: 1.4rem; margin: 0; color: var(--text-primary); }
.ca-subtitulo { margin: 4px 0 0; color: var(--text-secondary); font-size: 0.9rem; }

.ca-card {
  background: var(--secondary-bg-main);
  border: 1px solid var(--border-main);
  border-radius: 12px;
  padding: 14px 16px;
  margin-bottom: 14px;
  box-shadow: var(--shadow-sm);
}
.ca-card__header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; gap: 12px; }
.ca-card__titulo { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; color: var(--text-primary); }
.ca-card__icono { color: var(--primary-main); font-size: 1.05rem; }
.ca-card__acciones { display: flex; gap: 6px; }

.ca-codigo {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 6px;
  background: var(--bg-main);
  color: var(--text-secondary);
  font-size: 0.78rem;
  font-family: ui-monospace, monospace;
}
.ca-ruta { color: var(--text-secondary); font-size: 0.82rem; }

.ca-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: lowercase;
}
.ca-badge--exito  { background: color-mix(in srgb, var(--accent-success) 18%, transparent); color: var(--accent-success); }
.ca-badge--neutro { background: var(--bg-main); color: var(--text-muted); }

.ca-tabla { width: 100%; border-collapse: collapse; font-size: 0.88rem; }
.ca-tabla th, .ca-tabla td { padding: 8px 10px; border-bottom: 1px solid var(--border-main); text-align: left; }
.ca-tabla th { font-weight: 600; color: var(--text-secondary); background: var(--bg-main); }
.ca-tabla tbody tr:last-child td { border-bottom: 0; }
.ca-tabla__acciones { text-align: right; white-space: nowrap; }

.ca-info { padding: 14px; color: var(--text-secondary); }
.ca-info--vacio { padding: 8px 4px; font-size: 0.85rem; }

.ca-boton {
  border: 1px solid var(--border-main);
  background: var(--secondary-bg-main);
  color: var(--text-primary);
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 0.88rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}
.ca-boton:hover:not(:disabled) { background: var(--bg-main); }
.ca-boton:disabled { opacity: 0.6; cursor: not-allowed; }
.ca-boton--xs { padding: 4px 8px; font-size: 0.78rem; }
.ca-boton--primario   { background: var(--primary-main); border-color: var(--primary-main); color: #fff; }
.ca-boton--primario:hover:not(:disabled) { background: var(--primary-hover); border-color: var(--primary-hover); }
.ca-boton--secundario { background: transparent; }
.ca-boton--exito      { color: var(--accent-success); border-color: color-mix(in srgb, var(--accent-success) 40%, transparent); }
.ca-boton--peligro    { color: var(--accent-danger); border-color: color-mix(in srgb, var(--accent-danger) 40%, transparent); }
.ca-boton--peligro:hover:not(:disabled) { background: color-mix(in srgb, var(--accent-danger) 12%, transparent); }

.ca-modal-fondo {
  position: fixed; inset: 0; z-index: 2000;
  background: rgba(0, 0, 0, 0.45);
  display: flex; align-items: center; justify-content: center;
}
.ca-modal {
  background: var(--secondary-bg-main);
  color: var(--text-primary);
  border-radius: 12px;
  padding: 22px;
  min-width: 420px;
  max-width: 560px;
  border: 1px solid var(--border-main);
  box-shadow: var(--shadow-md);
}
.ca-modal h2 { font-size: 1.1rem; margin: 0 0 16px; }
.ca-modal label { display: block; margin-bottom: 10px; font-size: 0.85rem; color: var(--text-secondary); }
.ca-modal label small { color: var(--text-muted); }
.ca-modal__acciones { display: flex; justify-content: flex-end; gap: 8px; margin-top: 14px; }
.ca-modal--confirm p { color: var(--text-secondary); margin-bottom: 12px; }

.ca-input {
  width: 100%;
  background: var(--bg-main);
  color: var(--text-primary);
  border: 1px solid var(--border-main);
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 0.92rem;
  margin-top: 4px;
}
.ca-input:focus { outline: none; border-color: var(--border-focus); }
.ca-check { display: inline-flex; align-items: center; gap: 8px; }
.ca-check input { transform: scale(1.05); }
</style>
